module.exports = __webpack_public_path__ + "static/media/light-ledger.d622f901.svg";